import { IPlayer, playerToPlayerFullNameMap } from '@trackman/baseball-shared-components';

const isForeignIdMatch = (playFid: string, csvFid: string) => playFid.split('-').some((x) => x === csvFid);
const findPlayerInRoster = (roster: IPlayer[], name: string, foreignId: string) =>
  roster.find((p) => playerToPlayerFullNameMap(p) === name && p.foreignIds.some((fid) => isForeignIdMatch(fid, foreignId)));

export const csvImportUtils = { isForeignIdMatch, findPlayerInRoster };
